import { randmolyShuffledArray } from 'src/components/common/helper';
export const randamizingNavItems = (burgerMenueNavData) => {
  const homeIndex = burgerMenueNavData.findIndex((menu) => menu?.navigationItemText === 'Home');

  if (homeIndex !== -1) {
    let rest = burgerMenueNavData.filter((menu) => menu?.navigationItemOrderFixed !== 'True');
    let home = burgerMenueNavData.filter((menu) => menu?.navigationItemOrderFixed === 'True');
    const random = randmolyShuffledArray(rest);
    return [...home , ...random];
  } else {
    return randmolyShuffledArray(burgerMenueNavData);
  }
};
